(function () {
  function cleanText(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function normalizeTitle(value) {
    var title = cleanText(value);
    var lower = title.toLowerCase();
    if (lower === 'description' || lower === 'overview' || lower === 'key details' || lower.indexOf('feature') !== -1) return 'Description';
    if (lower.indexOf('spec') !== -1) return 'Specifications';
    if (lower.indexOf('compat') !== -1 || lower.indexOf('accessor') !== -1 || lower.indexOf('parts') !== -1) return 'Compatibility';
    if (lower.indexOf('deliver') !== -1 || lower.indexOf('shipping') !== -1 || lower.indexOf('return') !== -1 || lower.indexOf('warranty') !== -1) return 'Delivery & Returns';
    if (lower.indexOf('frequently') !== -1 || lower === 'faq' || lower === 'faqs') return 'FAQs';
    return title;
  }

  function collectSections(source) {
    var details = Array.prototype.slice.call(source.querySelectorAll('.em-product-accordion > details'));
    if (details.length) {
      return details.map(function (detail) {
        var clone = detail.cloneNode(true);
        var summary = clone.querySelector('summary');
        var title = normalizeTitle(summary ? summary.textContent : 'Description');
        if (summary) summary.remove();
        return { title: title, html: clone.innerHTML };
      }).filter(function (section) { return cleanText(section.html); });
    }
    var clone = source.cloneNode(true);
    var sections = [];
    var current = { title: 'Description', nodes: [] };
    Array.prototype.slice.call(clone.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && /^H[2-4]$/.test(node.tagName)) {
        if (current.nodes.length) sections.push(current);
        current = { title: normalizeTitle(node.textContent), nodes: [] };
      } else current.nodes.push(node);
    });
    if (current.nodes.length) sections.push(current);
    return sections.map(function (section) {
      var wrapper = document.createElement('div');
      section.nodes.forEach(function (node) { wrapper.appendChild(node); });
      return { title: section.title, html: wrapper.innerHTML };
    }).filter(function (section) { return cleanText(section.html); });
  }

  function mergeSections(sections) {
    var order = ['Description', 'Specifications', 'Compatibility', 'Delivery & Returns', 'FAQs'];
    var grouped = {};
    sections.forEach(function (section) {
      var title = normalizeTitle(section.title);
      if (order.indexOf(title) === -1) title = 'Description';
      grouped[title] = (grouped[title] || '') + section.html;
    });
    return order.filter(function (title) { return grouped[title]; }).map(function (title) { return { title: title, html: grouped[title] }; });
  }

  function buildProductDetails() {
    if (document.getElementById('em-pdp-upgrade')) return;
    var source = document.querySelector('.cc-product-details .product-description');
    if (!source) return;
    var sections = mergeSections(collectSections(source));
    if (!sections.length) return;
    var original = source.closest('.product-details__block, .product-details__tabs, .block');
    if (original) original.classList.add('em-pdp-original-description-hidden');

    var upgrade = document.createElement('section');
    upgrade.id = 'em-pdp-upgrade';
    upgrade.className = 'em-pdp-upgrade';
    var tabs = sections.map(function (section, index) {
      return '<button class="em-pdp-tab" type="button" role="tab" aria-selected="' + (index === 0 ? 'true' : 'false') + '" aria-controls="em-pdp-panel-' + index + '">' + section.title + '</button>';
    }).join('');
    var panels = sections.map(function (section, index) {
      return '<section class="em-pdp-panel' + (index === 0 ? ' is-active' : '') + '" id="em-pdp-panel-' + index + '" role="tabpanel"><button class="em-pdp-mobile-toggle" type="button" aria-expanded="' + (index === 0 ? 'true' : 'false') + '">' + section.title + '</button><div class="em-pdp-panel-content"><div class="em-pdp-copy">' + section.html + '</div></div></section>';
    }).join('');
    upgrade.innerHTML = '<div class="em-pdp-upgrade__inner"><div class="em-pdp-tabs" role="tablist" aria-label="Product details">' + tabs + '</div>' + panels + '</div>';
    var detailsSection = source.closest('.cc-product-details');
    var anchor = detailsSection || document.querySelector('.cc-main-product');
    if (anchor) anchor.insertAdjacentElement('afterend', upgrade);
    else source.insertAdjacentElement('beforebegin', upgrade);

    upgrade.querySelectorAll('.em-pdp-tab').forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        upgrade.querySelectorAll('.em-pdp-tab').forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
        upgrade.querySelectorAll('.em-pdp-panel').forEach(function (item) { item.classList.remove('is-active'); });
        tab.setAttribute('aria-selected', 'true');
        upgrade.querySelectorAll('.em-pdp-panel')[index].classList.add('is-active');
      });
    });
    upgrade.querySelectorAll('.em-pdp-mobile-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () { toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); });
    });
  }

  function bindBuyNow() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-em-buy-now]');
      if (!button || button.disabled) return;
      var form = button.closest('form');
      if (!form) return;
      event.preventDefault();
      button.disabled = true;
      button.textContent = 'Opening checkout...';
      fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (response) { if (!response.ok) throw new Error('Unable to add item'); window.location.assign('/checkout'); })
        .catch(function () { button.disabled = false; button.textContent = 'Buy Now'; var addButton = form.querySelector('button[name="add"]'); if (addButton) addButton.click(); });
    });
    var observer = new MutationObserver(function () {
      document.querySelectorAll('[data-em-buy-now]').forEach(function (button) {
        var form = button.closest('form');
        var addButton = form && form.querySelector('button[name="add"]');
        if (addButton && button.disabled !== addButton.disabled) button.disabled = addButton.disabled;
      });
    });
    observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'value'] });
  }

  function init() { buildProductDetails(); bindBuyNow(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
